module.exports = __webpack_public_path__ + "static/media/rectangle-15.d5d6b757.svg";